import * as ko from "knockout";
import * as fetchGoogleMaps from "fetch-google-maps";
import { App } from "../app";
import { Api } from "../app-api";

const divModel: HTMLDivElement = document.querySelector("#divPlaceSearchModel");
//const divRoot: see init()

export class ViewModel {
    apiKey: string;
    place: any;

    submit: () => void;

    constructor(model) {
        let self = this;

        const data = JSON.parse(model);

        self.apiKey = data.apiKey;

        self.submit = () => {
            if (self.place) {
                let url = Api.GetUrl("camp");
                url += "?place=" + self.place.place_id;
                window.location.href = url;
            }
            else {
                App.alertWarning("Type City or Postal Code/Zip and select from the list.");
            }
        }

        self.initMaps();
    }

    private initLookup(inputLookup, Maps) {
        let self = this;

        let service = new Maps.places.Autocomplete(inputLookup);
        service.setComponentRestrictions({ 'country': ['ca', 'us'] });
        service.setFields(['place_id']);

        service.addListener('place_changed', () => {
            const place = service.getPlace();

            if (!place.place_id) {
                App.alertWarning("No details available for input: '" + inputLookup.value + "'");
                return;
            }

            self.place = place;
        });
    }

    private initMaps() {
        let self = this;

        fetchGoogleMaps({
            apiKey: self.apiKey,
            language: "en",
            libraries: ["places"]
        }).then((Maps) => {
            Array.from(document.querySelectorAll(".pac-input"))
                .forEach(inputLookup => self.initLookup(inputLookup, Maps));
        });
    }
}

function init() {
    if (divModel) {
        let vm = new ViewModel(divModel.textContent);
        Array.from(document.querySelectorAll(".ko-place-search"))
            .forEach(root => ko.applyBindings(vm, root));
    }
}

$(document).ready(() => init());